module.exports = __webpack_public_path__ + "static/auiss-logo-2-91fbdbc3b7c7e6ff9c6233dfbe8bedfd.png";